import { TableRow, TableCell } from "@material-ui/core"
import { Add } from "@material-ui/icons"
import {
  MasterButton,
  ModalDeleteConfirm,
  TableAction,
  TableWrapper,
} from "App/Component/ui"
import { getComparator, stableSort } from "App/Component/ui/datatable/utils"
import { useDatatables } from "App/hooks"
import {
  convertToValidPrice,
  defaultDateDisplay,
  defaultToastError,
  defaultToastSuccess,
  formatNumber,
  isNull,
} from "App/utils/helpers"
import React, { useState, useContext, useEffect } from "react"
import { STATUS_TUTUP_TAGIHAN } from "utils/billing"
import { FormContext } from "../../context/FormContext"
import { deleteBayarById, headCells } from "./helpers"
import { ModalForm, RESET_STATE_BAYAR } from "./helpers"

function TabBayar({
  setNewData,
  rows,
  setShowModalKwitansi,
  setNilaiKwitansi,
}) {
  const [showModal, setShowModal] = useState(false)
  const { formData } = useContext(FormContext)
  const [formBayar, setFormBayar] = useState(RESET_STATE_BAYAR)
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false)

  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "id",
    orderByRow: ["id"],
  })

  useEffect(() => {
    ;(async () => {
      await setNewData()
    })()
  }, [formData.tagihan_id]) // eslint-disable-line react-hooks/exhaustive-deps

  async function deleteList() {
    const res = await deleteBayarById(formBayar.id)
    if (res.state) {
      defaultToastSuccess(res.message)
      await setNewData()
    } else {
      defaultToastError(res.message)
    }
    setShowModalDeleteConfirm(false)
  }

  function clickDelete(row) {
    setFormBayar({
      ...formBayar,
      id: row?.id,
    })
    setShowModalDeleteConfirm(!showModalDeleteConfirm)
  }

  const sisa =
    formData.pembayaran.total_tagihan - formData.pembayaran.total_pembayaran
  const selisihTagihan = formData.ditanggung.jumlah_selisih
  const sisaPembayaran = sisa + selisihTagihan

  const handleClickCetak = (nilai) => {
    setNilaiKwitansi(nilai)
    setShowModalKwitansi(true)
  }

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      {showModal && (
        <ModalForm
          setShowModal={setShowModal}
          formData={formBayar}
          setFormData={setFormBayar}
          setNewData={setNewData}
          tagihanId={formData.tagihan_id}
          status={formData.status}
          totalSaldo={formData.total_saldo}
          sisa={convertToValidPrice(sisaPembayaran)}
        />
      )}

      {sisaPembayaran > 0 && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "1rem",
          }}
        >
          <MasterButton
            type={"button"}
            color="green"
            outline={true}
            onClick={() => setShowModal(!showModal)}
            name="Bayar"
            size="sm"
            withIcon={true}
            icon={
              <Add
                width="15px"
                height="15px"
                style={{
                  marginLeft: "-0.5rem",
                }}
              />
            }
          />
        </div>
      )}

      <TableWrapper
        title=""
        setQ={setQ}
        witAddButton={false}
        type="CUSTOM"
        withExportButton={false}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
      >
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}
              >
                <TableCell
                  component="th"
                  scope="row"
                  padding="none"
                  align="center"
                >
                  {index + 1}
                </TableCell>
                <TableCell component="th" scope="row" padding="none">
                  <TableAction
                    clickDelete={
                      formData.status_tagihan !== STATUS_TUTUP_TAGIHAN
                        ? () => clickDelete(row)
                        : () => {}
                    }
                    isUpdate={false}
                    isDelete={
                      formData.status_tagihan !== STATUS_TUTUP_TAGIHAN
                        ? row.tipe_pembayaran_id === 4
                          ? false
                          : true
                        : false
                    }
                    isCetak
                    tooltipCetak="Cetak Kwitansi"
                    clickCetak={() => handleClickCetak(row.jumlah_bayar)}
                  />
                </TableCell>
                <TableCell align="left" width={"5%"}>
                  {row?.id}
                </TableCell>
                <TableCell align="left">
                  {defaultDateDisplay(row.tanggal_masuk)}
                </TableCell>
                <TableCell align="right">
                  {formatNumber(row.jumlah_bayar)}
                </TableCell>
                <TableCell align="left">
                  {isNull(row?.id_bayar_rekap) ? "Kasir" : "Rekap Tagihan"}
                </TableCell>
                <TableCell align="left">
                  {row?.isditanggung ? "Ditanggung" : "Non Ditanggung"}
                </TableCell>

                <TableCell align="left">{row?.nama_kas}</TableCell>
                <TableCell align="left">{row?.info}</TableCell>
                <TableCell align="left">
                  {formatNumber(row.kembalian_saldo)}
                </TableCell>
                <TableCell align="left">{row?.tipe_kartu}</TableCell>
                <TableCell align="left">{row?.no_kartu}</TableCell>
                <TableCell align="left">{row?.no_transfer}</TableCell>
              </TableRow>
            )
          })}
      </TableWrapper>
    </>
  )
}

export default TabBayar
